import anonymousRepositoryHelper from './anonymousRepositoryHelper';

function SystemSettingsRepository() {

  var self = this;
  var resourceBaseUrl = '/api/systemSettings';

  /**
   * Get portal settings including upload url and in release mode flag
   * @return {Promise}
   */
  self.getPortalSettings = function () {

    var resourceUrl = resourceBaseUrl + '/portalSettings';
    return anonymousRepositoryHelper.ajaxGet(resourceUrl);
  };
}

export default new SystemSettingsRepository();
